export var URL_SIZES = {
    RESIZED: 'resized',
    MULTI: 'multi',
    SCALED: 'scaled',
    PIXEL: 'pixel',
    THUMBNAIL: 'thumbnail',
    SQUARE: 'square',
    FULL: 'full',
    SAMPLE: 'sample',
    PRELOAD: 'preload',
    DOWNLOAD: 'download',
    DOWNLOAD_SAMPLE: 'download_sample',
    MAGNIFIED: 'magnified',
};
export var URL_TYPES = {
    HIGH_RES: 'img',
    LOW_RES: 'thumb',
    VIDEO: 'video',
};
//# sourceMappingURL=urlTypes.js.map